import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    color-scheme: light;
    --paper: #ffffff;
    --surface: #f5f5f4;
    --surface-strong: #ebebea;
    --ink: #1b1c1b;
    --brass: #8c7449;
    --font-mono: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
    --muted: #656669;
    --line: #dededc;
    --primary: #202122;
    --primary2: #f5f5f4;
    --gradient: linear-gradient(120deg, #fff, #f1f1f0);
    --font-family-primary: 'Inter', Arial, sans-serif;
    --gutter: clamp(24px, 6vw, 96px);
    --page-width: 1440px;
    font-size: 62.5%;
  }
  *, *::before, *::after { box-sizing: border-box; }
  html { scroll-behavior: smooth; scroll-padding-top: 110px; }
  body {
    margin: 0; min-width: 320px; background: var(--paper); color: var(--ink);
    font: 400 1.6rem/1.6 var(--font-family-primary);
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  #root { position: relative; width: 100%; }
  h1, h2, h3, h4 { font-family: var(--font-family-primary); font-weight: 550; line-height: 1.08; letter-spacing: -0.045em; }
  a { color: inherit; text-underline-offset: 0.2em; }
  button, input, textarea, select { font: inherit; }
  button, a, input, textarea { -webkit-tap-highlight-color: transparent; }
  button { cursor: pointer; }
  button:disabled { cursor: wait; opacity: 0.6; }
  button, a { touch-action: manipulation; }
  img, video { max-width: 100%; }
  :focus-visible { outline: 2px solid var(--ink) !important; outline-offset: 5px; }
  ::selection { background: #e4d9c3; color: #171819; }
  .sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }
  .skip-link { position: fixed; top: -80px; left: 20px; z-index: 2000; padding: 12px 20px; background: white; border: 1px solid var(--ink); }
  .skip-link:focus { top: 12px; }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @media (prefers-reduced-motion: reduce) {
    html { scroll-behavior: auto; }
    *, *::before, *::after { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; transition-duration: 0.01ms !important; }
  }
`;
export default GlobalStyle;
